import React from 'react';

import { observer } from 'mobx-react-lite';
import { InfoType } from 'stores/info_store';
import useStores from 'hooks/useStores';


type InfoContextType = {

    // createInfo: (identity: string, associated_type: string, associated_uuid: string) => Promise<InfoType>;

    // // Fetch and get one
    // fetchInfo: (uuid: string) => Promise<InfoType | null>;
    // getInfo: (uuid: string) => InfoType | null;

    // Fetch and get list by identity
    fetchListByParent: (identity_uuid: string, parent_type: string, parent_uuid: string, cursor?: string) => Promise<InfoType[]>;
    getListByParent: (identity_uuid: string, parent_type: string, parent_uuid: string) => InfoType[];

    // // Fetch and get list by association
    // fetchListByAssociationInfo: (identity: string, associated_type: string, associated_uuid: string) => Promise<InfoType[]>;
    // getListByAssociationInfo: (associated_type: string, associated_uuid: string) => InfoType[];

    // // Fetch and get list by Identity
    // fetchListByIdentity: (identity: string, identity: string) => Promise<InfoType[]>;
    // getListByIdentity: (identity: string) => InfoType[];

    // Contains all known Info items
    items: InfoType[];
}

export const InfoContext = React.createContext<InfoContextType>({
    // createInfo: () => { throw 'Not Implemented' },
    // fetchInfo: () => { throw 'Not Implemented' },
    // getInfo: () => { throw 'Not Implemented' },
    fetchListByParent: () => { throw 'Not Implemented' },
    getListByParent: () => { throw 'Not Implemented' },
    // fetchListByIdentityInfo: () => { throw 'Not Implemented' },
    // getListByIdentityInfo: () => { throw 'Not Implemented' },
    // fetchListByAssociationInfo: () => { throw 'Not Implemented' },
    // getListByAssociationInfo: () => { throw 'Not Implemented' },
    // fetchListByIdentity: () => { throw 'Not Implemented fetchListByIdentity' },
    // getListByIdentity: () => { throw 'Not Implemented getListByIdentity' },
    items: [] as InfoType[],
});




export const InfoProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { infoStore } = useStores();

    const fetchListByParent = async (
        identity_uuid: string,
        parent_type: string,
        parent_uuid: string,
        cursor?: string
    ) => {
        return infoStore.fetchListByParent(identity_uuid, parent_type, parent_uuid, cursor)
            .then(() => {
                return getListByParent(parent_uuid);
            });
    };

    const getListByParent = (parent_uuid: string) => {
        return infoStore.items.slice().filter((item) => item.parent_uuid === parent_uuid);
    };


    const data = {
        fetchListByParent,
        getListByParent,
        items: infoStore.items.slice(),
    };

    return (
        <InfoContext.Provider value={data}>{ children }</InfoContext.Provider>
    );

});
